import React, { useCallback, useEffect } from "react";
import "./main.scss";
import { createPortal } from "react-dom";
import Loader from "components/Loader/Loader";
import { MdDone } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";

const modalElement = document.getElementById("modal-root");

interface Props {
  isOpen: boolean;
  title?: string;
  children: React.ReactNode;
  onClose: Function;
  onClick?: Function;
  onClick1?: Function;
  txtField?: string;
  cancelLabel?: string;
  onSubmit?: any;
  loading?: boolean;
  // Disable the footer buttons without showing the loading overlay (e.g. while
  // a confirmed action runs and its own progress UI is rendered as children).
  actionsDisabled?: boolean;
}

const Modal = ({
  title = undefined,
  children,
  isOpen,
  onClose,
  onClick,
  onClick1,
  txtField,
  cancelLabel,
  onSubmit,
  loading,
  actionsDisabled,
}: Props) => {
  const handleEscape = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    },
    [onClose]
  );

  useEffect(() => {
    if (isOpen) document.addEventListener("keydown", handleEscape, false);
    return () => {
      document.removeEventListener("keydown", handleEscape, false);
    };
  }, [handleEscape, isOpen]);

  const isCloseInHeader = onClick === undefined && onClick1 === undefined;

  if (modalElement != null)
    return createPortal(
      isOpen ? (
        <div className="g-modal-deletion">
          <div className="g-modal-container loading-container">
            {loading && <Loader />}
            <div className="g-modal-header">
              {isCloseInHeader
                ? (<>
                  <span>{title}</span>
                  <button onClick={() => onClose()}><RxCross2 size={15} /></button>
                </>)
                : title}
            </div>
            <>
              <div className="g-modal-body">
                {!onSubmit && (
                  <>
                    {children}
                    <div className="g-modal-footer">
                      {!isCloseInHeader
                        && (cancelLabel === undefined
                          ? <button onClick={() => onClose()} disabled={loading || actionsDisabled}><RxCross2 size={20} /></button>
                          : <label className="tempLabel" onClick={() => onClose()}>
                            {cancelLabel}
                          </label>)}
                      {onClick1 &&
                        <label className="tempLabel" onClick={() => onClick1()}>
                          {txtField}
                        </label>}
                      {onClick && <button onClick={() => onClick()} disabled={loading || actionsDisabled}><MdDone /></button>}
                    </div>
                  </>
                )}
                {onSubmit && (
                  <form onSubmit={onSubmit}>
                    {children}
                    <div className="g-modal-footer">
                      {!isCloseInHeader
                        && (cancelLabel === undefined
                          ? <button onClick={() => onClose()} disabled={loading || actionsDisabled}><RxCross2 size={20} /></button>
                          : <label className="tempLabel" onClick={() => onClose()}>
                            {cancelLabel}
                          </label>)}
                      {onClick1 &&
                        <label className="tempLabel" onClick={() => onClick1()}>
                          {txtField}
                        </label>}
                      <button type="submit" disabled={loading || actionsDisabled}><MdDone /></button>
                    </div>
                  </form>
                )}
              </div>
            </>
          </div>
        </div>
      ) : null,
      modalElement
    );
  else {
    console.error("Modal root element should be defined in HTML template!");
    return null;
  }
};
export default Modal;
